/**
 * SPA navigation paths (browser URLs). For HTTP API paths, use `src/services/endpoints/`.
 */
export const APP_ROUTES = {
  BRIDGE: '/bridge',
  DASHBOARD: '/dashboard',
  VACANCY: {
    SEARCH: '/rec/vacancy/search',
    VIEW: (id: number | string) => `/rec/vacancy/search/${id}/view`,
    EDIT: (id: number | string) => `/rec/vacancy/search/${id}/edit`,
    ADD: '/rec/vacancy/add',
  },
  APPLICANT: {
    SEARCH: '/rec/applicant/search',
    ADD: '/rec/applicant/add',
    PROFILE: (id: number | string) => `/rec/applicant/search/${id}/profile`,
    MESSAGES: (id: number | string) => `/rec/applicant/search/${id}/profile?tab=messages`,
    ADDITIONAL_INFO: (id: number | string) => `/rec/applicant/search/${id}/profile?tab=additional`,
  },
  LINKEDIN: {
    SEARCH: '/rec/linkedin/search',
  },
  USER: {
    PROFILE: '/user/profile',
  },
} as const;
